import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { Component } from 'react';
import { BrandingProvider, initTheme } from '@astrumu/core-ui-branding';
import { ErrorFallback } from '../Fallback/index.js';
import { IconIllustration } from '../../Icon/index.js';
import { ErrorBoundaryFooter } from './Footer/index.js';
import { AppContainer, AppWrapper, ConditionalRender } from '../../Container/index.js';
import getErrorMessage, { DEFAULT_ERROR_MESSAGE, isWithHomePageButton } from '../error-messages.js';
export class ErrorBoundary extends Component {
    constructor() {
        super(...arguments);
        this.state = { error: null };
        this.firstCharToUppercase = (message) => message.charAt(0).toUpperCase() + message.slice(1);
        this.getErrorDescription = (error) => {
            const message = typeof error === 'object' ? error?.message : error;
            return getErrorMessage(message);
        };
        this.getNavigation = (errorMessage) => {
            if (isWithHomePageButton(errorMessage)) {
                return {
                    route: '/',
                    text: 'go to the home page'
                };
            }
            return undefined;
        };
    }
    static getDerivedStateFromError() {
        return { error: { message: DEFAULT_ERROR_MESSAGE } };
    }
    componentDidCatch(error) {
        this.setState({ error });
    }
    render() {
        const { error } = this.state;
        const { children, background, footerAppearance, palette = 'light', isFooterVisible = true } = this.props;
        const theme = initTheme();
        if (error) {
            const description = this.getErrorDescription(error);
            const navigation = this.getNavigation(description);
            return (_jsx(BrandingProvider, { theme: theme, children: _jsxs(AppWrapper, { minHeight: "100vh", background: background, children: [_jsx(AppContainer, { children: _jsx(ErrorFallback, { palette: palette, icon: _jsx(IconIllustration.UndrawOops, {}), title: "Looks like something went wrong", navigation: navigation, description: description }) }), _jsx(ConditionalRender, { isContentVisible: isFooterVisible, children: _jsx(ErrorBoundaryFooter, { appearance: footerAppearance }) })] }) }));
        }
        return children;
    }
}
//# sourceMappingURL=index.js.map